export default {
  bookingReservations: [],
  bookingReservationsStatuses: [],
  bookingReservationsFilter: {},

  filters: {},
  paginationOptions: {}
};
